import React, { useState } from 'react';
import '../styles/Certificates.css';
import salani from './main.jpeg';
import digital1 from './digital.pdf';
import flare from './flare.pdf';
import python from './completion certificate.pdf';
import wordpress from './wordpress.pdf';
import freelancing from './freelancing.pdf';
import graphic from './graphic.pdf';
import { FiChevronDown, FiExternalLink } from 'react-icons/fi';

const Certificates = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const certs = [
        { title: "Web Design Specialist", org: "Saylani Mass IT Training — 2024", image: salani },
        { title: "Graphic Design (Basic)", org: "Digital's Flare — 2024", image: flare},
          { title: "Freelancing ", org: "DigiSkills Pakistan — 2024", image: freelancing},
        { title: "WordPress Development", org: "DigiSkills Pakistan— 2024", image: wordpress },
        { title: " Graphic Design", org: "DigiSkills Pakistan— 2025", image: graphic },
        { title: "Digital Marketing", org: "DigiSkills Pakistan— 2025", image: digital1 },
      
        { title: "Python Basic", org: "Code in Place — 2025", image: python }
    ];

    return (
        <section className="cert-section" id="certificates">
            <div className="container">
                <div className="cert-header-wrapper">
                    {/* Hover line effect isi par apply hoga */}
                    <h2 className="cert-title-main">My <span className="highlight">Certificates</span> </h2>
                </div>

                <div className="timeline-container">
                    {certs.map((cert, index) => (
                        <div key={index} className={`timeline-node ${activeIndex === index ? 'is-active' : ''}`}>
                            <div className="timeline-top" onClick={() => setActiveIndex(activeIndex === index ? null : index)}>
                                <div className="timeline-left-group">
                                    <div className="timeline-point"></div>
                                    <div className="timeline-meta">
                                        <h3>{cert.title}</h3>
                                        <p>{cert.org}</p>
                                    </div>
                                </div>
                                <FiChevronDown className="timeline-icon-arrow" />
                            </div>
                            
                            <div className="timeline-hidden-box">
                                <div className="inner-reveal">
                                    <a href={cert.image} target="_blank" rel="noreferrer" className="cert-action-btn">
                                        View Full Certificate <FiExternalLink />
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Certificates;